// @ts-nocheck
import setHeaderFullOpacity from "@store/Framework/Store/Bunzl/Components/Header/Handlers/SetHeaderFullOpacity";
import { HeaderIsFullOpacityParameter } from "@store/Framework/Store/Bunzl/Components/Header/HeaderTypes";
import { useDispatch } from "react-redux";

export default () => {
    const dispatch = useDispatch();

    return (parameter: HeaderIsFullOpacityParameter) => {
        dispatch(setHeaderFullOpacity(parameter));
    };
};
